export default __webpack_public_path__ + "static/media/battlefieldcommander.42a870c6.png";